import { render, staticRenderFns } from "./ServerEdit.vue?vue&type=template&id=caad01d4&scoped=true&"
import script from "./ServerEdit.vue?vue&type=script&lang=js&"
export * from "./ServerEdit.vue?vue&type=script&lang=js&"
import style0 from "./ServerEdit.vue?vue&type=style&index=0&id=caad01d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caad01d4",
  null
  
)

export default component.exports